import { z } from 'zod';

export type CustomPageActionSubject = {
  id: number | string;
  name: string;
  link?: string;
  kind?: string;
};

export enum CustomPageChatContextIdentifier {
  FrmAccountInsights = 'frm-account-insights',
  FrmTerritoryInsights = 'frm-territory-insights',
  FrmPolicySearch = 'frm-policy-search',
  FrmPatientInsights = 'frm-patient-insights',
  FrmFaqs = 'frm-faqs',
}

export const BuiltInCodePageEnum = z.enum([
  'frm-account-insights',
  'frm-policy-search',
  'frm-territory-insights',
  'test',
]);

export type BuiltInCodePage = z.infer<typeof BuiltInCodePageEnum>;

export const BUILT_IN_CODE_PAGE_LABELS: Record<BuiltInCodePage, string> = {
  ['frm-account-insights']: 'FRM Account Insights',
  ['frm-policy-search']: 'FRM Policy Search',
  ['frm-territory-insights']: 'FRM Territory Insights',
  ['test']: 'Test',
};

export const BuiltInCodeProviderDataSchema = z.object({
  codePage: BuiltInCodePageEnum,
});

export type BuiltInCodeProviderData = z.infer<typeof BuiltInCodeProviderDataSchema>;
